import React, { useCallback, useEffect, useRef, useState } from 'react';

const STILL_FRAME = '/boar_head-0001.png';

const ANIMATIONS = [
  { src: '/boar_blink_a_png.png', duration: 2900 },
  { src: '/boar_sniff_a_png.png', duration: 2800 },
  { src: '/boar_bangs_a_png.png', duration: 2800 },
  { src: '/boar_shake_head_a_png.png', duration: 4000 },
  { src: '/boar_turn_head_a_png.png', duration: 5900 },
];

// Random interval range between animations (ms)
const MIN_INTERVAL = 4000;
const MAX_INTERVAL = 12000;

interface BoarMascotProps {
  className?: string;
}

export const BoarMascot: React.FC<BoarMascotProps> = ({ className = 'h-20' }) => {
  const [src, setSrc] = useState(STILL_FRAME);
  const isAnimatingRef = useRef(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const playRandomAnimation = useCallback(() => {
    if (isAnimatingRef.current) return;
    isAnimatingRef.current = true;

    const anim = ANIMATIONS[Math.floor(Math.random() * ANIMATIONS.length)];

    // Cache-bust to force APNG replay from frame 1
    setSrc(`${anim.src}?t=${Date.now()}`);

    // After the animation duration, swap back to still frame
    setTimeout(() => {
      setSrc(STILL_FRAME);
      isAnimatingRef.current = false;
      scheduleNext();
    }, anim.duration);
  }, []);

  const scheduleNext = useCallback(() => {
    const delay = MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL);
    timerRef.current = setTimeout(playRandomAnimation, delay);
  }, [playRandomAnimation]);

  useEffect(() => {
    scheduleNext();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [scheduleNext]);

  return (
    <img
      src={src}
      alt="Gruntled mascot"
      className={`mx-auto ${className}`}
    />
  );
};
